__turbopack_context__.v({
  "vehicle-history": "vehicle-history-section-module-scss-module__A9tRTW__vehicle-history",
  "vehicle-history-adv": "vehicle-history-section-module-scss-module__A9tRTW__vehicle-history-adv",
  "vehicle-history-adv-2": "vehicle-history-section-module-scss-module__A9tRTW__vehicle-history-adv-2",
  "vehicle-history-container": "vehicle-history-section-module-scss-module__A9tRTW__vehicle-history-container",
  "vehicle-history-title": "vehicle-history-section-module-scss-module__A9tRTW__vehicle-history-title",
});
